// -----------------------CIRCLE ROUTES--------------------------
export const CIRCLE_ROOT = '/circle';

export const CIRCLE_ROUTES = {
  HOME: {
    NAME: 'Circle Home',
    PATH: `${CIRCLE_ROOT}`,
    ROUTE: `${CIRCLE_ROOT}`,
  },
  GAME: {
    NAME: 'Circle Game',
    ROUTE: `${CIRCLE_ROOT}/game`,
    PATH: `${CIRCLE_ROOT}/game`,
  },
  LEADERBOARD: {
    NAME: 'Circle Leaderboard',
    ROUTE: `${CIRCLE_ROOT}/leaderboard`,
    PATH: `${CIRCLE_ROOT}/leaderboard/:leaderboardType?`,
  },
};

// ----------------- END OF CIRCLE ROUTES -----------------------
